import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { AuthService } from 'src/app/service/auth.service';
import { GenericValidator } from 'src/app/validation/general-validation';

@Component({
  selector: 'app-email',
  templateUrl: './email.component.html'
})
export class EmailComponent implements OnInit {

  windowheight: any;
  divHeight: number;
  EmailForm: FormGroup;
  displayMessage: any;
  private validationMessages: { [key: string]: { [key: string]: string } };
  private genericValidator: GenericValidator;
  onResize() {
    this.ResizeHeight();
  }

  // Called function on initial and window resize
  ResizeHeight() {
    this.windowheight = localStorage.getItem('WindowHeight');
    this.divHeight = this.windowheight - 100;
  }

  constructor(private form: FormBuilder, private authService: AuthService, public dialogRef: MatDialogRef<EmailComponent>) {
    this.authService.getValidationMessage().subscribe(resp => {
      dialogRef.disableClose = true;
      this.validationMessages = resp.EmailForm;
      this.genericValidator = new GenericValidator(this.validationMessages);
    });
  }

  ngOnInit(): void {
    this.EmailForm = this.form.group({
      Email: ['', [Validators.required, Validators.email]]
    });
  }

  SendEmail() {
    if (this.EmailForm.invalid) {

      this.EmailForm.updateValueAndValidity();
      this.displayMessage = this.genericValidator.processMessages(this.EmailForm, true);
      return;
    }

    this.dialogRef.close(this.EmailForm.value.Email);
  }

  Close() {
    this.dialogRef.close();
  }

}
